export const isLocal = process.env.TROX_ENVIRONMENT === "local";
export const isDevelopment = process.env.TROX_ENVIRONMENT === "development";
export const isStaging = process.env.TROX_ENVIRONMENT === "staging";
export const isProduction = process.env.TROX_ENVIRONMENT === "production";
